<template>
  <v-container>
    <div>
      <v-layout wrap align-center>
        <v-flex xs12 sm6>
          <h2>ปรับแต่งหน้าจอสมัครงาน : ตำแหน่งงาน</h2>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="default-input">
            <v-text-field
              id="search"
              v-model="search"
              name="search"
              single-line
              :placeholder="$t('Search')"
              outline
              clearable
              prepend-inner-icon="search"
              hide-details
              @blur="debouncedSearch()"
              @keydown.enter="debouncedSearch()"
              @input="debouncedSearch()"
            ></v-text-field>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center my-3>
        <v-flex xs12 sm6>
          <h3>* ลักษณะงานที่สนใจ / Job Interests</h3>
        </v-flex>
        <v-flex xs12 sm6 style="display: flex; justify-content: flex-end">
          <v-btn
            outline
            color="primary"
            :disabled="Boolean(editPosition) === true"
            @click="editPosition = !editPosition"
          >
            <v-icon class="mr-2">swap_vert</v-icon>{{ $t('bbl.sort_job_position') }}
          </v-btn>
          <v-btn depressed color="primary" @click="previewDialogOpen = true">
            {{ $t('preview') }}
          </v-btn>
          <v-btn depressed color="primary" @click="jobManageFormDialogOpen = true">
            <em class="fas fa-plus mr-1"></em> {{ $t('bbl.add_job_interest') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <div>
        <draggable
          :list="data"
          class="dragArea"
          :move="checkMove"
          item-key="id"
          :animation="200"
          @end="onDragEnd"
        >
          <div v-for="job in data" :key="job.id" style="display: flex; width: 100%">
            <v-layout row>
              <v-flex v-if="editPosition" shrink pa-1>
                <em class="fas fa-grip-vertical" />
              </v-flex>
              <v-flex grow pa-1>
                <JobItem :item="job" @onRefetchList="handleRefetchList" />
              </v-flex>
            </v-layout>
          </div>
        </draggable>
        <div style="display: flex; justify-content: center">
          <v-btn v-if="editPosition" outline color="primary" @click="editPosition = false">
            {{ $t('bbl.cancel_sort_job_position') }}
          </v-btn>
          <v-btn v-if="editPosition" depressed color="primary" @click="savePositionBangkokbankJob">
            {{ $t('bbl.save_sort_job_position') }}
          </v-btn>
        </div>
      </div>

      <div class="text-xs-left pb-2">
        <v-pagination
          v-model="pageNumber"
          :total-visible="15"
          :length="pageLength"
          @input="handleChangePage"
        ></v-pagination>
      </div>

      <JobManageFormDialog
        v-if="jobManageFormDialogOpen"
        :dialog-open="jobManageFormDialogOpen"
        form-type="add"
        @onCloseDialog="jobManageFormDialogOpen = false"
        @onSaveSuccess="handleSaveFormSuccess"
      />

      <PreviewJobDialog
        v-if="previewDialogOpen"
        v-model="previewDialogOpen"
        :job-list="data"
        @onCloseDialog="previewDialogOpen = false"
      />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import bangkokbankApi from '@/api/bangkokbank.js'
import draggable from 'vuedraggable'
import JobItem from './JobItem.vue'
import PreviewJobDialog from './PreviewJobDialog.vue'
import JobManageFormDialog from './JobManageFormDialog.vue'

export default {
  components: {
    draggable,
    JobItem,
    PreviewJobDialog,
    JobManageFormDialog
  },

  data() {
    return {
      editPosition: false,
      limit: 10,
      offset: 0,
      debounceTimeout: null,
      search: '',
      pageTemp: 1,
      pageNumber: 1,
      total: 0,

      loading: false,
      headers: [
        { text: '', value: '', sortable: false, width: '1%' },
        { text: 'Name TH', value: 'name_en' },
        { text: 'Name En', value: 'name_th' },
        { text: '', value: '', sortable: false, width: '2%' }
      ],
      data: [],
      previewDialogOpen: false,
      jobManageFormDialogOpen: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleRefetchList()
  },
  methods: {
    checkMove() {
      return this.editPosition
    },
    onDragEnd(evt) {
      const draggedIndex = evt.oldIndex
      const futureIndex = evt.newIndex

      if (draggedIndex !== futureIndex) {
        this.data.forEach((data, index) => {
          data.sort = index
        })
      }
    },
    async handleRefetchList() {
      this.getData(this.limit, 0)
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.getData(vm.limit, vm.offset)
      }
    },
    async getData(limit, offset) {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const data = {
          search: vm.search,
          page_id: vm.selectedBot.pageid
        }
        if (limit !== 'none' && offset !== 'none') {
          Object.assign(data, {
            limit,
            offset
          })
        }
        let response = await bangkokbankApi.getBangkokbankJobInterests(data)

        if (response && response.status === 200) {
          vm.data = response.data.data ? response.data.data : []
          vm.total = response.data.total || 0
          vm.$store.commit('CLEAR_LOADING')
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    debouncedSearch() {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }
      this.debounceTimeout = setTimeout(() => {
        this.handleRefetchList()
      }, 500)
    },
    async savePositionBangkokbankJob() {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const data = {
          bangkokbank_job: vm.data,
          page_id: vm.selectedBot.pageid
        }

        const response = await bangkokbankApi.updateSortBangkokbankJobInterests(data)
        if (response && response.status === 204) {
          vm.$swal({
            title: 'อัพเดทสำเร็จ',
            type: 'success',
            confirmButtonText: this.$t('Confirm')
          })
          vm.getData(vm.limit, 0)
          vm.$store.commit('CLEAR_LOADING')
        }
        vm.editPosition = false
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
        await vm.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `${error.message}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    handleSaveFormSuccess() {
      this.jobManageFormDialogOpen = false
      this.handleRefetchList()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/bblcareer/Job/Job.vue